module.exports = __webpack_public_path__ + "img/logo-jianguo.7bb85cd2.png";